import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { EditorHtmlField, useModel, useSettings, Utils } from 'app/main/components';

interface PhoneCallsEditNotesDialogProps {
	model: any;
	updateRefresh?: VoidFunction;
}

export const showPhoneCallsEditNotesDialog = (props: PhoneCallsEditNotesDialogProps) =>
	openDialog({
		children: <PhoneCallsEditNotesDialog {...props} />,
		maxWidth: 'sm',
		fullWidth: true,
		onClose: () => {}
	});

export default function PhoneCallsEditNotesDialog(props: PhoneCallsEditNotesDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings('phonecalls');

	const { model, sendChange, save } = useModel({ baseModel: props.model, settings, isEdit: true });

	const updateNotes = () => {
		save({
			storedName: 'ext_st_phonecalls_update',
			onSuccess: () => {
				dispatch(Utils.alertSuccessMsg(t));
				dispatch(closeDialog());
				props.updateRefresh?.();
			}
		});
	};

	return (
		<>
			<DialogTitle>{model.phca_note ? t('DIALOG_TITLE_NOTES_EDIT') : t('DIALOG_TITLE_NOTES_ADD')}</DialogTitle>
			<DialogContent>
				<EditorHtmlField name="phca_note" value={model.phca_note} sendChange={sendChange} isEdit />
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_BACK')}</Button>
				<Button color="secondary" onClick={updateNotes}>
					{t('DIALOG_ACTION_SAVE')}
				</Button>
			</DialogActions>
		</>
	);
}
